import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
import { CtaButton } from './ui/CtaButton';
import { OFFER_ANCHOR, PACK_IMAGE, PRODUCT } from '../data/content';
const EASE = [0.23, 1, 0.32, 1] as const;
export function Hero() {
  return <header className="bg-night" data-id="element-91" data-mp="4lqkp0lrnl5m">
      <div className="mx-auto flex max-w-page flex-col items-center px-3 pb-7 pt-5 text-center sm:px-6 sm:pb-9" data-id="element-92" data-mp="4mruz2uyk3ma">
        <motion.p initial={{
        opacity: 0,
        y: -8
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.25,
        ease: EASE
      }} className="rounded-full bg-volt/15 px-3 py-1 text-[0.65rem] font-extrabold uppercase tracking-[0.2em] text-volt sm:text-xs" data-id="element-93" data-mp="12862k3i3uktp">
          ⚡ Método de aprendizaje paso a paso
        </motion.p>

        <motion.h1 initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.28,
        ease: EASE,
        delay: 0.04
      }} className="mt-3 max-w-4xl font-display text-[1.5rem] uppercase leading-[1.05] text-white sm:text-4xl lg:text-[3rem]" data-id="element-94" data-mp="3d21sdxnwkknq">
          El sistema completo para aprender{' '}
          <span className="text-volt" data-id="element-95" data-mp="3o5j4tesrxrnx">electricidad domiciliaria desde cero</span>
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.28,
        ease: EASE,
        delay: 0.08
      }} className="mt-2 max-w-2xl text-[0.85rem] font-semibold leading-snug text-steel sm:text-base" data-id="element-96" data-mp="39cfm343g57vm">
          Aprende una habilidad útil, comprende cómo funciona una instalación y
          abre nuevas posibilidades — sin perderte entre cientos de videos y
          tutoriales.
        </motion.p>

        <motion.p initial={{
        opacity: 0,
        y: 8
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.28,
        ease: EASE,
        delay: 0.11
      }} className="mt-3 rounded-md bg-electric px-3 py-1.5 font-display text-[0.72rem] uppercase tracking-wide text-white sm:text-sm" data-id="element-97" data-mp="2vjg5szvub9n0">
          ⚡ {PRODUCT} · 6 Tomos + 5 Bonos
        </motion.p>

        <motion.a href={OFFER_ANCHOR} initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        ease: EASE,
        delay: 0.14
      }} className="mt-3 block w-full max-w-xl" data-id="element-98" data-mp="nb1o3ec0ka16">
          <img src={PACK_IMAGE} alt={`${PRODUCT}: 6 tomos digitales y 5 bonos incluidos`} className="mx-auto w-full rounded-xl" data-id="element-99" data-mp="1b0vubd1tv0cg" />
        </motion.a>

        <div className="mt-4 flex w-full flex-col items-center gap-2" data-id="element-100" data-mp="112pwp7n20gde">
          <CtaButton size="lg" data-id="element-101" data-mp="110wq1scfxw5e">🚀 SÍ, QUIERO COMENZAR AHORA</CtaButton>
          <p className="flex flex-wrap items-center justify-center gap-x-2 gap-y-1 text-[0.7rem] font-bold uppercase tracking-wide text-steel sm:text-xs" data-id="element-102" data-mp="x032x16toldk">
            Acceso Digital Inmediato
            <span aria-hidden="true" data-id="element-103" data-mp="3hqahwlxb75jg">•</span>
            <span className="flex items-center gap-1" data-id="element-104" data-mp="3htg5fwqahzd2">
              <ShieldCheckIcon size={13} className="text-volt" data-id="element-105" data-mp="1xaceczu3ndrn" />
              Garantía de 7 Días
            </span>
          </p>
        </div>
      </div>
    </header>;
}